"use client";

import React from "react";
import removeImage from "../../../public/remove.png";
import acceptImage from "../../../public/accept.png";
import Image from "next/image";

const LogoDesignPackage = () => {  
    return (
        <div className="container">
            <div className="row text-center">
                <p>Our dedicated design and marketing professionals can deliver! Our team will see to it that your logo
                    elevates the brand of your business.
                    This delivers a lasting impression on your prospects, site visitors and clients. We are committed to
                    achieving maximum results for your business!
                </p>

                <h5><strong>We offer packages that will fit any budget!</strong> </h5>
                <br />
                <p> Our team will develop the right solution at a highly competitive budget. </p>
                <br />

                <h4 className="fw-bold display-5 text-center textHad">CUSTOM LOGO DESIGN PACKAGES!</h4>
            </div>

            <div className="theme_spacing">
                <div className="container">
                    <div className="tblbg">
                        <div className="table-responsive">

                            <table
                                className="table table-striped table-condensed dataTable table caption-top tablecls0 table-hover domains_table">
                                <thead>

                                    <tr className="domain_sec" role="row">
                                        <th scope="col">
                                            <center>Features</center>
                                        </th>
                                        <th scope="col">
                                            <center>Basic Plan</center>
                                        </th>
                                        <th scope="col">
                                            <center>Startup Plan</center>
                                        </th>
                                        <th scope="col">
                                            <center>Gold Plan</center>
                                        </th>
                                        <th scope="col">
                                            <center>Enterprise Plan</center>
                                        </th>
                                        <th scope="col">
                                            <center>Unlimited Plan</center>
                                        </th>
                                        <th scope="col">
                                            <center>Ultimate Plan</center>
                                        </th>
                                    </tr>

                                </thead>

                                <tbody>
                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Logo Design Concepts</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>3</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>6</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Unlimited Revisions</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>3</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>3</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                    </tr>
                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Custom Website Design</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><strong>5 Page Website Design</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>10 Page Website Design</strong></center>
                                        </td>
                                        <td className="">
                                            <center><strong>Unlimited</strong></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem even">
                                        <td className="">
                                            <center><strong>Free Formats: JPEG,Ai,Giff,Psd,EPS</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Free Color Options</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Free Stationery Design Set</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Letterhead, Envelope, Business Card</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>100% Satisfaction Guarantee</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>24 X 7 Customer Support</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Money Back Guarantee*</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Copyright Protection of Your Logo Design</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>

                                    </tr>
                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Stock Photos</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><strong>10</strong></center>
                                        </td>

                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Email Addresses</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><strong>10</strong></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>1 Design Concept</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>


                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>1 Year Domain Name</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>1 Year Web Hosting</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>


                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Search Engine Submission</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Stationery Design Set</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Social Media Pages</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Facebook Page Design</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>Twitter Theme Design</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>

                                    <tr className="ResultItem odd">
                                        <td className="">
                                            <center><strong>YouTube Theme Page</strong></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={removeImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                        <td className="">
                                            <center><Image src={acceptImage} alt="yes" width={20} height={20} /></center>
                                        </td>
                                    </tr>
                                    <tr role="row">
                                        <th scope="col">
                                        </th>
                                        <th scope="col">
                                            <br />
                                            <div>
                                                <center>
                                                    <h1 className="price_duration">$95</h1>
                                                </center>
                                            </div>
                                            <br />
                                            <div className="d-flex justify-content-center">
                                                <a href="https://clients.temok.com/cart.php?a=add&pid=170"
                                                    className="btn btn-primary btnfill0">Order Now <i
                                                        className="fa-solid"></i></a>
                                            </div>

                                        </th>
                                        <th scope="col">
                                            <br />
                                            <div>
                                                <center>
                                                    <h1 className="price_duration">$115</h1>
                                                </center>
                                            </div>
                                            <br />
                                            <div className="d-flex justify-content-center">
                                                <a href="https://clients.temok.com/cart.php?a=add&pid=171"
                                                    className="btn btn-primary btnfill0">Order Now <i
                                                        className="fa-solid"></i></a>
                                            </div>

                                        </th>
                                        <th scope="col">
                                            <br />
                                            <div>
                                                <center>
                                                    <h1 className="price_duration">$119</h1>
                                                </center>
                                            </div>
                                            <br />
                                            <div className="d-flex justify-content-center">
                                                <a href="https://clients.temok.com/cart.php?a=add&pid=168"
                                                    className="btn btn-primary btnfill0">Order Now <i
                                                        className="fa-solid"></i></a>
                                            </div>

                                        </th>
                                        <th scope="col">
                                            <br />
                                            <div>
                                                <center>
                                                    <h1 className="price_duration">$495</h1>
                                                </center>
                                            </div>
                                            <br />
                                            <div className="d-flex justify-content-center">
                                                <a href="https://clients.temok.com/cart.php?a=add&pid=169"
                                                    className="btn btn-primary btnfill0">Order Now <i
                                                        className="fa-solid"></i></a>
                                            </div>
                                        </th>
                                        <th scope="col">
                                            <br />
                                            <div>
                                                <center>
                                                    <h1 className="price_duration">$695</h1>
                                                </center>
                                            </div>
                                            <br />
                                            <div className="d-flex justify-content-center">
                                                <a href="https://clients.temok.com/cart.php?a=add&pid=172"
                                                    className="btn btn-primary btnfill0">Order Now <i
                                                        className="fa-solid"></i></a>
                                            </div>
                                        </th>
                                        <th scope="col">
                                            <br />
                                            <div>
                                                <center>
                                                    <h1 className="price_duration">$955</h1>
                                                </center>
                                            </div>
                                            <br />
                                            <div className="d-flex justify-content-center">
                                                <a href="https://clients.temok.com/cart.php?a=add&pid=173"
                                                    className="btn btn-primary btnfill0">Order Now <i
                                                        className="fa-solid"></i></a>
                                            </div>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default LogoDesignPackage;